import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";

const DepositEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(true);
  const [banks, setBanks] = useState([]);

  useEffect(() => {
    Promise.all([fetchDeposit(), fetchBanks()]);
  }, [id]);

  const fetchDeposit = () => {
    return Http.get(`/accounts/deposits/${id}`)
      .then((res) => {
        const data = res.data.data;
        // Convert status to lowercase if it exists
        if (data.status) {
          data.status = data.status.toLowerCase();
        }
        setInputs(data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchBanks = () => {
    return Http.get("/accounts/banks")
      .then((res) => {
        setBanks(res.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = () => {
    Http.put(`/accounts/deposits/${id}`, inputs)
      .then((res) => {
        navigate("/deposits", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Edit Deposit</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Deposit Information</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>Bank <span className="text-danger">*</span></label>
                    <select
                      className="form-control"
                      name="bank_id"
                      value={inputs.bank_id || ""}
                      onChange={handleChange}
                    >
                      <option value="">Select Bank</option>
                      {banks.map((bank) => (
                        <option key={bank.id} value={bank.id}>
                          {bank.name} - {bank.account_number}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg">
                    <label>Amount <span className="text-danger">*</span></label>
                    <input
                      type="number"
                      className="form-control"
                      name="amount"
                      value={inputs.amount || ""}
                      onChange={handleChange}
                      placeholder="Enter Amount"
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-lg">
                    <label>Deposit Date <span className="text-danger">*</span></label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={inputs.date ? inputs.date.split('T')[0] : ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>Counter No</label>
                    <input
                      type="text"
                      className="form-control"
                      name="counter_no"
                      value={inputs.counter_no || ""}
                      onChange={handleChange}
                      placeholder="Enter Counter Number"
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-lg">
                    <label>Status</label>
                    <select
                      className="form-control"
                      name="status"
                      value={inputs.status || ""}
                      onChange={handleChange}
                    >
                      <option value="active">Active</option>
                      <option value="returned">Returned</option>
                    </select>
                  </div>
                  <div className="col-lg">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      name="description"
                      value={inputs.description || ""}
                      onChange={handleChange}
                      placeholder="Enter Description"
                      rows="3"
                    ></textarea>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Update
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepositEdit;